// InvictusA produktdata — rediger navne, beskrivelser, priser (DKK) og billeder her.
// Priserne er foreløbige testpriser inkl. moms og kan tilpasses frit.

export const products = [
  {
    slug: "invictusa-25l-tromle",
    name: "InvictusA 25L Tromle",
    volume: "25 liter",
    price: 3495,
    badge: "Mest populær",
    category: "Tætningsvæske",
    image: "/assets/drum-25l.png",
    description:
      "Ekstrem dækbeskyttelse til tungt entreprenørmateriel, hjullæssere, gravemaskiner og landbrugsmaskiner. Forsegler punkteringer op til 26 mm Ø — mens maskinen kører.",
    longDescription:
      "InvictusA 25L tromlen er den professionelle løsning til store maskinflåder. Den vandbaserede, frostsikrede formel med Kevlar®-fibre fordeles jævnt i dækket under kørsel og danner en permanent tætning ved hver punktering — op til 26 mm Ø. Én enkelt behandling er som regel tilstrækkelig i hele dækkets levetid. Produktet er ikke klassificeret som farligt, kræver ingen faremærkning og vaskes bort med vand.",
    specs: [
      ["Indhold", "25 liter"],
      ["Tætner huller op til", "26 mm Ø"],
      ["Anbefalet pumpe", "Metalpumpe (0,25 L pr. slag)"],
      ["Frostsikret", "Ja — vandbaseret formel"],
      ["Faremærkning", "Ikke klassificeret"],
      ["Levetid i dækket", "Hele dækkets levetid"],
    ],
  },
  {
    slug: "invictusa-5l-dunk",
    name: "InvictusA 5L Dunk",
    volume: "5 liter",
    price: 895,
    badge: "Til mindre maskiner",
    category: "Tætningsvæske",
    image: "/assets/drum-25l.png",
    imageNote: "Vist med 25L tromle — dedikeret 5L foto er på vej",
    description:
      "Kompakt løsning til trillebøre, børrehjul, minilæssere, havetraktorer og mindre maskinpark. Samme ekstreme Kevlar®-beskyttelse i håndterbar størrelse.",
    longDescription:
      "InvictusA 5L dunken er ideel til mindre flåder, entreprenører med få maskiner og til have- og parkmaskiner. Indeholder præcis samme vandbaserede, frostsikrede Kevlar®-formel som 25L tromlen og forsegler punkteringer op til 26 mm Ø. Nem at opbevare, nem at håndtere — og skånsom mod dæk, slanger, fælg og ventil.",
    specs: [
      ["Indhold", "5 liter"],
      ["Tætner huller op til", "26 mm Ø"],
      ["Anbefalet pumpe", "Plastpumpe (100 ml pr. slag)"],
      ["Frostsikret", "Ja — vandbaseret formel"],
      ["Faremærkning", "Ikke klassificeret"],
      ["Levetid i dækket", "Hele dækkets levetid"],
    ],
  },
  {
    slug: "metalpumpe-25l",
    name: "Metalpumpe til 25L Tromle",
    volume: "0,25 L pr. slag",
    price: 1250,
    badge: "Professionelt udstyr",
    category: "Pumper",
    image: "/assets/metal-pump.png",
    panelTheme: "dark",
    description:
      "Industriel metalpumpe til hyppig påfyldning direkte gennem dækventilen. Leverer præcist 1/4 liter (250 ml) pr. pumpeslag — hurtig påfyldning uden at tømme dækket for luft.",
    longDescription:
      "Metalpumpen er bygget til professionelt brug på værkstedet og i marken. Den skrues direkte på 25L tromlen og doserer præcist 0,25 liter pr. pumpeslag, så du hurtigt rammer den beregnede mængde. Ved påfyldning med metalpumpen skal dækket ikke tømmes for luft — kun ventilkeglen fjernes, så du er tilbage i drift på få minutter.",
    specs: [
      ["Dosering", "0,25 liter (250 ml) pr. pumpeslag"],
      ["Materiale", "Metal / messing-fittings"],
      ["Kompatibel med", "InvictusA 25L tromle"],
      ["Påfyldning", "Uden at tømme dækket for luft"],
    ],
  },
  {
    slug: "plastpumpe-5l",
    name: "Plastpumpe til 5L Dunk",
    volume: "100 ml pr. slag",
    price: 345,
    badge: "Let & nem",
    category: "Pumper",
    image: "/assets/plastic-pump.png",
    description:
      "Kompakt manuel pumpe med ergonomisk greb og tætningsring i InvictusA-blå. Leverer præcist 100 ml pr. pumpeslag — perfekt til trillebøre og mindre dæk.",
    longDescription:
      "Plastpumpen er den lette og prisvenlige vej til præcis dosering fra 5L dunken. Hvert pumpeslag leverer 100 ml, så selv små dæk på trillebøre, børrehjul og havetraktorer doseres nøjagtigt. Pumpen monteres direkte på dunken og er klar til brug på sekunder.",
    specs: [
      ["Dosering", "100 ml pr. pumpeslag"],
      ["Materiale", "Slagfast plast"],
      ["Kompatibel med", "InvictusA 5L dunk"],
      ["Påfyldning", "Dækket tømmes for luft før påfyldning"],
    ],
  },
];

export const formatPrice = (price, currency) =>
  `${Number(price || 0).toLocaleString("da-DK")} ${String(currency || "").toUpperCase()}`.trim();

export const getProduct = (slug) => products.find((p) => p.slug === slug);
